import React from "react";
import propTypes from "prop-types";
import { Button, Col, Modal, Row, theme, Collapse } from "antd";
import { PRODUCT_TYPE, REPORT_FILTER } from "../constants/string";
import { URL_REPORT } from "../constants/urls";
import ReportModal from "../components/reports/ReportModal";
import Lottie from "lottie-react";
import lottieReport from "../asset/lottie_report.json"

export default function PaymentReportView() {
  const [targetReport, setTargetReport] = React.useState(null);
  const [loading, setLoading] = React.useState(null);
  const [items, setItems] = React.useState([]);

  const {
		token: { colorInfoText }
	} = theme.useToken();

  const reports = [
    {
      id: 1, 
      label: "1. รายงานตรวจรับน้ำยางสดรายวัน S", 
      detail: "รายงานตรวจรับน้ำยางสดรายวัน S",
      filters: [{ name: REPORT_FILTER.DATE, placeholder: "วันที่", required: true }],
      url: URL_REPORT.DAILY_RAW_LATEX_REPORT_S
    },
    {
      id: 2, 
      label: "2. รายงานตรวจรับน้ำยางสดรายวัน D", 
      detail: "รายงานตรวจรับน้ำยางสดรายวัน D",
      filters: [
        { name: REPORT_FILTER.DATE_RANGE, placeholder: "วันที่", required: true },
        { name: REPORT_FILTER.RAW_LATEX_SUPPLIER, placeholder: "ผู้ขายน้ำยางสด", required: false },
      ],
      url: URL_REPORT.DAILY_RAW_LATEX_REPORT_D
    },
    {
      id: 3, 
      label: "3. รายงานการนำเงินเข้าบัญชี", 
      detail: "รายงานการนำเงินเข้าบัญชี",
      filters: [
        { name: REPORT_FILTER.DATE, placeholder: "วันที่ตัดบัญชี", required: true },
        { name: REPORT_FILTER.BANK_ACCOUNT, placeholder: "บัญชีบริษัท" }
      ],
      url: URL_REPORT.ACCOUNT_INCOME
    },
    {
      id: 4,
      label: "4. รายงานการชั่งเพื่อลง DRC",
      detail: "รายงานการชั่งเพื่อลง DRC",
      filters: [{ name: REPORT_FILTER.DATE, placeholder: "วันที่", required: true }],
      url: URL_REPORT.TRUCK_TRANSACTION_DRC_REPORT
    },
    {
      id: 5, 
      label: "5. รายงานวิเคราะห์ %DRC ประจำเดือน", 
      detail: "รายงานวิเคราะห์ %DRC ประจำเดือน",
      filters: [{ name: REPORT_FILTER.MONTH, placeholder: "เดือน", required: true }],
      url: URL_REPORT.DRC_MONTHLY
    },  
  ]

  const manageItems = () => {
    let list = []
    list.push({
        key: '1',
        label: 'รายงานรับซื้อน้ำยางสด/จ่ายเงิน',
        children: renderReportList(reports),
    })
    setItems(list)
  }
    

  const renderReportList = (list) => {
    return (
      <Row 
        gutter={[16, 16]}
        style={{marginTop: 16, marginBottom: 16}}>
        {list.map(item => (
          <Col key={item.id} xl={8} sm={12} xs={24}>
            <Button
              style={{width: "100%", justifyContent: "left", borderColor: colorInfoText}}
              disabled={(item && item.url) ? false : true} // disable
              onClick={() => setTargetReport(item)}>
                {item.label}
            </Button>
          </Col>
        ))}
      </Row>
    )
  }

  React.useEffect(() => {
    manageItems()
  },[])

  return (
    <div>
      {targetReport && loading != null &&
				<Modal
          maskClosable={false}
					title={
            <>
              กำลังสร้าง - {targetReport.label}
            </>
          }
					open={loading != null}
					style={{top: 20,}}
					closable={false}
					footer={[]}>
          <Lottie animationData={lottieReport} />
				</Modal>
			}
      
        <Collapse
          style={{marginTop: 24, justifyContent: "left"}}
          defaultActiveKey={['1']}
          items={items}
        />

      {/* Modal */}
			<ReportModal
				namePrefix={targetReport ? targetReport.label : null}
				open={targetReport ? true : false}
				data={targetReport}
        target={targetReport}
				onStartLoading={() => setLoading(true)}
				onEndLoading={() => setLoading(null)}
				onClose={() => setTargetReport(null)}/>
    </div> 
  )
}